const formatGBP = (amount: any) => {
	if (!amount) return

	const numValue = Number(amount)

	return new Intl.NumberFormat('en-GB', {
		style: 'currency',
		currency: 'GBP',
		minimumFractionDigits: Number.isInteger(numValue) ? 0 : 2,
		maximumFractionDigits: 2
	}).format(amount)
}

export default formatGBP
